import styled, { css } from 'styled-components';
import { ColorsV2, getToken, sizes, spaces } from '@electricjs/arc';

/**
 * Shared styles for CopilotKit chat components
 * Used in both full-page chat and drawer chat views
 *
 * @copilotkit-version 1.51.2
 * Note: CSS class selectors target CopilotKit's internal DOM structure.
 * These are not documented as stable APIs and may break on updates.
 */

/**
 * CopilotKit CSS variable overrides to match the Arc design system.
 * Import this wherever CopilotKit components are rendered to ensure
 * consistent colors (e.g. loading dots, icons, backgrounds).
 */
export const copilotKitColorOverrides = css`
  /* CopilotKit CSS Variables - Match Arc Design System */
  /* Primary action color (used for icons, buttons, loading dots) */
  --copilot-kit-primary-color: ${getToken(ColorsV2.PRIMARY)};

  /* Text color that contrasts with primary */
  --copilot-kit-contrast-color: ${getToken(ColorsV2.TEXT)};

  /* Main background */
  --copilot-kit-background-color: ${getToken(ColorsV2.BACKGROUND_ALT)};

  /* Secondary background for cards/panels */
  /* --copilot-kit-secondary-color: inherit; */

  /* Primary text color for content (agent messages) */
  --copilot-kit-secondary-contrast-color: ${getToken(ColorsV2.TEXT)};

  /* Border color for dividers */
  /* --copilot-kit-separator-color: inherit; */

  /* Muted color for disabled states */
  /* --copilot-kit-muted-color: inherit; */
`;

export const CopilotKitChatContainer = styled.div`
  width: 100%;
  height: 100%;
  max-height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;

  /* Add Arc Pane styling - elevated with padding, border, and shadow */
  background-color: ${getToken(ColorsV2.BACKGROUND_CONTENT)};
  border: solid 1px ${getToken(ColorsV2.GRAY_LIGHT)};
  border-radius: ${sizes.size_8_rem};
  padding: ${spaces.space_l_rem};
  padding-bottom: ${spaces.space_xs_rem};
  box-shadow: 0 4px 8px -2px ${getToken(ColorsV2.PRIMARY_DARKEST)}1f;

  ${copilotKitColorOverrides}
`;
